// HOOKS
import { useState, useEffect } from "react";
// COMPONENTS
import { ReactComponent as RefreshIcon } from "../../assets/icons/refresh.icon.svg";
import { ReactComponent as HelpIcon } from "../../assets/icons/help.icon.svg";
import Popover from "../popover/popover.component";

const DEFAULT_CLASSNAMES = {
  container: "relative flex flex-row gap-2",
  iconContainer: "flex flex-col gap-1",
  helpIcon: "fill-secondary h-4 w-4",
  input:
    "focus:w-[200px] w-[100px] text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none",
  button:
    "relative shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-5 py-2 bg-primary text-white hover:bg-secondary",
  refreshIcon: "fill-white",
  buttonValue:
    "absolute right-[1px] top-[1px] flex items-center justify-center text-center text-xs leading-none min-w-[20px] min-h-[20px] active:drop-shadow group-hover:bg-primary group-hover:text-white rounded-full text-white bg-secondary",
  popover:
    "font-ubuntuRegular h-[150px] w-[300px] backdrop-blur-sm z-40 right-full top-1/3 absolute flex flex-col justify-center bg-greenGlass rounded-lg p-2",
};

const Refresh = ({
  seconds = 0,
  minimumValue = 10,
  handleEvent = () => {},
  classNames = DEFAULT_CLASSNAMES,
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const [time, setTime] = useState(seconds);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (+time === 0) return setTimer(0);
    if (timer > time && time >= minimumValue) return setTimer(time);
    const interval = setInterval(() => {
      if (timer === 0) {
        if (time < minimumValue && +time !== 0) {
          setTime(minimumValue);
          alert(`Minimum refresh time is ${minimumValue} seconds`);
        }
        handleEvent();
        setTimer(time);
      } else {
        setTimer(timer - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [time, timer, minimumValue, handleEvent]);

  const handleChange = (event) => {
    setTime(event.target.value);
  };

  return (
    <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
      <div
        className={
          classNames?.iconContainer || DEFAULT_CLASSNAMES.iconContainer
        }
      >
        <HelpIcon
          onMouseEnter={() => setShowPopover(true)}
          onMouseLeave={() => setShowPopover(false)}
          className={classNames?.helpIcon || DEFAULT_CLASSNAMES.helpIcon}
        />
      </div>
      <input
        onChange={handleChange}
        type="number"
        name="refreshTimer"
        value={time}
        min={0}
        placeholder="Refresh Timer"
        className={classNames?.input || DEFAULT_CLASSNAMES.input}
      />
      <button
        onClick={handleEvent}
        className={classNames?.button || DEFAULT_CLASSNAMES.button}
      >
        <RefreshIcon
          className={classNames?.refreshIcon || DEFAULT_CLASSNAMES.refreshIcon}
        />
        <span
          className={classNames?.buttonValue || DEFAULT_CLASSNAMES.buttonValue}
        >
          {timer}
        </span>
      </button>
      {/* popover */}
      {showPopover && (
        <Popover>
          <div>
            <p>Set the interval in seconds, to refetch table content.</p>
            <br />
            <p>0: No refetching</p>
            <p>{minimumValue}: Minimum Refetch Value</p>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default Refresh;
